<template>
  <label
    :class="_class"
    v-on="$listeners"
  >
    <span :class="_classItem">
      <input
        v-bind="$attrs"
        type="radio"
        :checked="_checked"
        :name="name"
        @change.stop="onChange"
        :disabled="_disabled"
        :value="value"
      >
      <i :class="_classIcon" />
    </span>
    <span :class="_classChild">
      <slot />
    </span>
  </label>
</template>

<script>
const name = 'ten-radio';

export default {
  name,
  inject: {
    group: {
      default: undefined,
    },
    formItem: {
      from: 'tenFormItem',
      default: null,
    },
  },
  props: {
    /**
     * 是否禁用
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * 对应原生 input 的 value 属性
     */
    value: [String, Number, Boolean],
    /**
     * @model
     *
     * checked 是否选中，对应事件 change
     */
    checked: Boolean,
    /**
     * 对应原生 input 的 name 属性
     */
    name: String,
  },
  computed: {
    _class() {
      return [
        {
          [`${name}`]: !this.buttonType,
          [`${name}--disabled`]: this._disabled,
          [`${name}--checked`]: this._checked,
          ['ten-button-radio ten-button ten-button--size-default']: this._isButton,
          'ten-button-radio--checked ten-button--type-primary': this._checked && this._isButton,
        },
      ];
    },
    _classIcon() {
      return [
        `${name}__radio-inner`,
      ];
    },
    _classItem() {
      return [
        `${name}__radio`,
      ];
    },
    _classChild() {
      return [
        `${name}__child`,
      ];
    },
    _disabled() {
      if (this.group && this.group.disabled) {
        return true;
      }
      return this.disabled;
    },
    _isButton() {
      return this.group ? this.group.type === 'button' : false;
    },
    _checked() {
      if (this.group) {
        return this.group.value === this.value;
      }
      return this.checked;
    },
  },
  methods: {
    onChange(event) {
      const { checked } = event.target;

      event.target.checked = this._checked;
      if (this.group) {
        this.group.$emit('memberChange', { value: this.value, checked });
      } else {
        this.$emit('change', checked);
        this.formItem && this.formItem.$emit('form.change');
      }
    },
  },
};
</script>
